import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <h3>{I18n.t("papp.settings.ProductsSettingsView.hint.p1")}</h3>
    <p>{I18n.t("papp.settings.ProductsSettingsView.hint.p2")}</p>

    <h3>{I18n.t("papp.settings.ProductsSettingsView.hint.p3")}</h3>
    <p>{I18n.t("papp.settings.ProductsSettingsView.hint.p4")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/settings/ProductsSettingsView/ProductsSettingsHint.jsx